interface VisibilityConfig {
  show?: string[];
  hide?: string[];
}

const TYPE_USER_VISIBILITY: Record<number, VisibilityConfig> = {
  1: {
    show: ['reinsurerId'],
    hide: ['companyId', 'agentId', 'clientId'],
  },
  2: {
    show: ['companyId'],
    hide: ['reinsurerId', 'agentId', 'clientId'],
  },
  3: {
    show: ['agentId'],
    hide: ['companyId', 'reinsurerId', 'clientId'],
  },
  4: {
    show: ['clientId'],
    hide: ['companyId', 'agentId', 'reinsurerId'],
  },
};

export const applyTypeUserVisibility = (
  typeUserId: number,
  fields: any[],
) => {
  const config = TYPE_USER_VISIBILITY[typeUserId];
  let idUpdated = false;

  if (!config) return;
  
  fields.forEach((field) => {
    if (config.show?.includes(field.key)) {
      field.hidden = false;
    }

    if (config.hide?.includes(field.key)) {
      field.hidden = true;
    }

    if(!idUpdated && field.key == 'typeUserId'){
      field.value = typeUserId;
      idUpdated = true;
    }
  });
};